import { useMutation } from "react-query";
import http from "infra/http";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";

function useReenviarEmailConta() {
  return useMutation(
    (ids: string[]) => {
      return http.post(`/v1/conta/reenviar`, {
        ids,
      });
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
      onSuccess: () => {
        showSuccess();
      },
    }
  );
}

export default useReenviarEmailConta;
